import { createSelector } from "@reduxjs/toolkit";
import _ from "lodash";
import { selectArticlegroupsMap } from "./selectArticlegroupsMap";

export const selectArticlegroupChildrenMap = createSelector([selectArticlegroupsMap], (articlegroupsMap) => {
  const parentToChildrenSet = _.reduce(
    articlegroupsMap,
    (acc: PartialRecord<string, PartialRecord<string, true>>, articlegroup) => {
      if (!articlegroup) {
        return acc;
      }

      const { id, parentId, category } = articlegroup;

      if (parentId && articlegroupsMap[parentId]) {
        acc[parentId] = acc[parentId] || {};
        acc[parentId][id] = true;
      }

      if (category) {
        acc[category] = acc[category] || {};
        acc[category][id] = true;
      }

      return acc;
    },
    {}
  );

  const result: PartialRecord<string, string[]> = _.mapValues(parentToChildrenSet, (childrenSet) =>
    _.keys(childrenSet).sort((a, b) => (articlegroupsMap[a]?.sortKey ?? 0) - (articlegroupsMap[b]?.sortKey ?? 0))
  );
  return result;
});
